<div class="scv2-print-label scv2-label">
  <div class="scv2-label-head">
    <div class="scv2-label-carrier">{{ carrierName }}</div>
    <div class="scv2-label-service">{{ order.service }}</div>
  </div>
  <div class="scv2-label-tag">SHIP FROM</div>
  <div class="scv2-label-from">{{ storeName }}<br />{{ storeAddress }}</div>
  <div class="scv2-label-tag">SHIP TO</div>
  <div class="scv2-label-to">
    {{ order.customer }}<br />
    <span class="scv2-label-to-addr">{{ order.address }}</span>
  </div>
  <div class="scv2-label-barcode"></div>
  <div class="scv2-label-tracking">{{ order.tracking }}</div>
  <div class="scv2-label-foot">
    <span>WT: {{ order.weight || '2.4' }} LB</span>
    <span>Order #{{ order.id }}</span>
  </div>
</div>
